@if (!isLoading) {
  @if (data()?.personalData) {
    <app-right-detail [data]="data()"></app-right-detail>
  } @else {
    <app-not-found></app-not-found>
  }
} @else {
  <app-async-loading></app-async-loading>
}
